import { useState } from 'react';

export default function FaqCollapse({ item }) {
	const [isCollapsed, setIsCollapsed] = useState(true);

	const toggleCollapse = () => {
		setIsCollapsed(!isCollapsed);
	};

	return (
		<div className="faq-item">
			<div className="question" onClick={toggleCollapse}>
				<span>{item.question}</span>
				<span>{isCollapsed ? '+' : '-'}</span>
			</div>
			<div className={`answer ${isCollapsed ? 'hidden' : ''}`}>{item.answer}</div>
		</div>
	);
}
